export default __webpack_public_path__ + "static/media/GT-Cinetype-Bold.0a4bd63f.otf";